/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Common API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { ApiResponseFilterItem, GetV9FiltersParams } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getFilter
 */
export const getV9Filters = (
  params: MaybeRef<GetV9FiltersParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseFilterItem>(
    { url: `/api/v9/filters`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9FiltersQueryKey = (params?: MaybeRef<GetV9FiltersParams>) => {
  return ['api', 'v9', 'filters', ...(params ? [params] : [])] as const;
};

export const getGetV9FiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9Filters>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9FiltersParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV9Filters>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9FiltersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9Filters>>> = ({ signal }) =>
    getV9Filters(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9Filters>>,
    TError,
    TData
  >;
};

export type GetV9FiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getV9Filters>>>;
export type GetV9FiltersQueryError = ErrorType<unknown>;

/**
 * @summary getFilter
 */

export function useGetV9Filters<
  TData = Awaited<ReturnType<typeof getV9Filters>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9FiltersParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV9Filters>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9FiltersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
